<style scoped>
.empty-faucets {
    padding: 15px;
}

.faucet-name,
.faucet-serial {
    padding: 15px 10px;
}

.faucet-name {
    text-align: left;
}

.faucet-row {
    border-bottom: 1px solid rgba(128, 128, 128, 0.479);
}

.all-faucets-action-buttons-block {
    padding: 15px 0;
}
</style>


<template>
<div>
    <loader-component v-if="loader"></loader-component>
    <div v-if="!loader" class="container-fluid">
        <div class="row all-faucets-action-buttons-block">
            <div class="col-6"><a class="aquazor-btn" @click="enabledAll">Разблокировать все</a></div>
            <div class="col-6"><a class="aquazor-btn-red" @click="disabledAll">Заблокировать все</a></div>
        </div>
        <div class="row faucet-row" v-for="(faucet, index) in faucets" :key="index">
            <div class="col-6 faucet-name">
                {{ faucet.name }}
            </div>
            <div class="col-4 faucet-serial">
                {{ deviceSerialNumber(faucet.serial_number) }}
            </div>
            <div class="col-2 faucet-active-checkbox-block">
                <input  :id=getCheckboxIdentification(index)
                        v-model="faucet.block" 
                        @change="changeFaucetStatus(faucet.id, faucet.block)" type="checkbox" autocomplete="off">
                <label :for=getCheckboxIdentification(index)>.</label>
            </div>
        </div>
        <div v-if="faucets.length == 0" class="empty-faucets">Хммм, пользователь есть, а кранов нет ... не порядок</div>
    </div>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import loader from './loader.vue'

export default {
    created() {
        get_faucets(this)
    },
    data() {
        return {
            faucets: [],
            loader: true,
            set_faucets_data: {}
        }
    },
    components: {
        'loader-component': loader,
    },
    props: ['id_user'],
    methods: {
        getCheckboxIdentification: function(index) {
            return 'faucet-active-' + index
        },
        changeFaucetStatus: function (id_faucet, status) {
            console.log([id_faucet, status])
            this.set_faucets_data[id_faucet] = status ? false : true
            waitOtherStatusFaucets(this, this.set_faucets_data)
        },
        disabledAll: function (){
            this.faucets.forEach((faucet, index) => {
                this.set_faucets_data[faucet.id] = false
                this.faucets[index].block = true
            });
            saveStatusesFaucets(this, this.set_faucets_data)
        },
        enabledAll: function (){
            this.faucets.forEach((faucet, index) => {
                this.set_faucets_data[faucet.id] = true
                this.faucets[index].block = false
            });
            saveStatusesFaucets(this, this.set_faucets_data)
        },
        deviceSerialNumber: function (number) {
            var serial_number = number.split("-").join("")
            serial_number = serial_number.toUpperCase()
            if (serial_number.length > 0) {
                serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
            }
            return serial_number
        }
    },
}

function get_faucets(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_user', vue_obj.id_user)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor-users/list_user_faucets',
                data: post_data
            })
            .then(function (response) {
                vue_obj.faucets = response.data.faucets
                vue_obj.loader = false
            })
            .catch(function (error) {

            })
    }
}

function waitOtherStatusFaucets(vue_obj, set_faucets_data) {
    setTimeout(() => {
        if (vue_obj.set_faucets_data == set_faucets_data) {
            saveStatusesFaucets(vue_obj, set_faucets_data)
            vue_obj.set_faucets_data = {}
        }
    }, 5000);
}

function saveStatusesFaucets(vue_obj, set_faucets_data) {
    const post_data = new URLSearchParams();
    post_data.append("token", localStorage.token);
    var statuses_for_request = []
    Object.keys(set_faucets_data).forEach(function(id_faucet,index) {
        statuses_for_request.push(id_faucet + ',' + set_faucets_data[id_faucet])
    });
    statuses_for_request = statuses_for_request.join('&')
    post_data.append('statuses_data', statuses_for_request)

    axios({
            method: 'POST',
            url: config.API_HOST + '/aquazor-users/update_faucets_status',
            data: post_data
        })
        .then(function (request) {
            // console.log(request)
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                console.log(error.response.data.exception)
            }
        })
}
</script>



// WEBPACK FOOTER //
// src/components/elements/user-faucets.vue